import moment from 'moment-timezone';

/** The backend refuses a by-day report longer than this (STAFF_REPORT_BY_DAY_MAX_DAYS). */
export const BY_DAY_MAX_DAYS = 93;

/**
 * Whether the by-day view can run for this date filter: it needs a start date and at most
 * BY_DAY_MAX_DAYS calendar days, both ends included. No end date means "through today".
 */
export function byDayRangeAllowed(start, end, tz) {
    if (!start) {
        return false;
    }
    const zone = tz || 'UTC';
    const startDay = moment.tz(start, 'YYYY-MM-DD', zone);
    const endDay = end ? moment.tz(end, 'YYYY-MM-DD', zone) : moment.tz(zone).startOf('day');
    if (!startDay.isValid() || !endDay.isValid()) {
        return false;
    }
    const days = endDay.diff(startDay, 'days') + 1;
    return days >= 1 && days <= BY_DAY_MAX_DAYS;
}

/** Response-time columns show minutes with one decimal; a missing time stays empty. */
export function secondsToMinutes(seconds) {
    if (seconds === null || seconds === undefined || Number.isNaN(Number(seconds))) {
        return null;
    }
    return Math.round(Number(seconds) / 6) / 10;
}

/**
 * Average response time over all the rows' replies: each row's average weighted by its
 * replies to guests, which is exactly the average over every reply. A median does not
 * combine this way, so the totals row leaves the median empty.
 */
export function weightedAverageResponseSeconds(rows) {
    let replies = 0;
    let weighted = 0;
    (rows || []).forEach((row) => {
        const n = row.reply_to_guest_count || 0;
        if (n > 0 && row.avg_response_seconds !== null && row.avg_response_seconds !== undefined) {
            replies += n;
            weighted += row.avg_response_seconds * n;
        }
    });
    return replies > 0 ? weighted / replies : null;
}
